import script from "./choseCoupon.vue?vue&type=script&setup=true&lang=js"
export * from "./choseCoupon.vue?vue&type=script&setup=true&lang=js"

import "./choseCoupon.vue?vue&type=style&index=0&id=7b22c554&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b22c554"]])

export default __exports__